import React, { useState } from "react";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import CustomDialog from "../../../../../components/Dialog/DiaComp";
import { TextGutHeart } from "./TextGutHeart";
import { SourcesGutHeart } from "./SourcesGutHeart";

export default function DiaTextHeart() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <div>

        <IconButton onClick={handleOpen} size="small" >
            <InfoIcon sx={{fontSize: '160%', color: 'background.iconlight', '&:hover': { color: 'primary.light'}, }}/>
        </IconButton>   
      
        <CustomDialog open={open} onClose={handleClose}

          title="GUT - HEART AXIS"

          content={ <TextGutHeart />}
          
          sources={ <SourcesGutHeart /> }
        />
      </div>
    );
  }